import { Card, Container } from 'react-bootstrap';
import './CardWrapper.css';

function CardWrapper({ children, theme, title }) {
  return (
    // <Container className='cardWrapperContainer'>

    <Card className="card-first">
      <Card.Header className={`${theme !== 'light' ? 'bg-'+ theme +' text-white' : 'text-dark-customizable h5'} text-center`}>
        {title}
      </Card.Header>

      <Card.Body>
        {children}
        </Card.Body>

    </Card>
    // </Container>

  );
}

export default CardWrapper;
